import { render, staticRenderFns } from "./addList.vue?vue&type=template&id=25156ab1&scoped=true"
import script from "./addList.vue?vue&type=script&lang=js"
export * from "./addList.vue?vue&type=script&lang=js"
import style0 from "./addList.vue?vue&type=style&index=0&id=25156ab1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25156ab1",
  null
  
)

export default component.exports